import crud from './_crud'
import { callApi } from 'utils/api'
import { clientLogin } from './app'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'incident_log',
	'el registro de incidencia',
	'los registros de incidencias'
)

const addIncidentLog = (item, images, options = {}) => {
	return async (dispatch, getState) => {
		const state = getState()

		let res = await callApi('/incident_log/add_incident_log', {
			json: false,
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				item: JSON.stringify(item),
				images,
			},
			successMessage: `Se agregó el registrro de incidente correctamente.`,
		})
		dispatch({
			type: 'ADD_INCIDENT_LOG',
			response: res.body,
		})
		return res.body
	}
}

const updateIncidentLog = (item, images, urls) => {
	return async (dispatch, getState) => {
		const state = getState()
		console.log(urls)
		console.log(images)
		let res = await callApi(`/incident_log/updateIncidentLog/${item.id}`, {
			json: false,
			method: 'POST',
			body: {
				item: JSON.stringify(item),
				images,
				urls: JSON.stringify(urls),
			},
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se actualizó el registro de incidente correctamente.`,
		})

		let stored_item = res.body

		dispatch({
			type: `UPDATE_INCIDENT_LOG`,
			response: stored_item,
		})
	}
}

const deleteIncidentLog = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		let res = await callApi(`/incident_log/deleteIncidentLog/${item.id}`, {
			json: false,
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se eliminó el registro de incidente correctamente.`,
		})

		dispatch({
			type: `DELETE_INCIDENT_LOG`,
			response: res.body,
		})
	}
}

const bulkSyncIncidentLog = (
	{ deleteItems, updateItems, createItems },
	options = {}
) => {
	return async (dispatch, getState) => {
		const state = getState()

		let res = await callApi(`/incident_log/bulkSyncIncidentLog`, {
			method: 'POST',
			body: JSON.stringify({
				deleteItems,
				updateItems,
				createItems,
			}),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se sincronizaron los registros de incidentes correctamente.`,
		})

		let stored_item = res.body
		return dispatch(actions.load({ ...options, force: true }))
	}
}

const loadIncidentLogs = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/incident_log/utils/get_incident_log`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options?.params,
		})

		dispatch({
			type: 'LOAD_INCIDENT_LOGS',
			response: res.body,
		})

		return res.body
	}
}

const importIncidentLogs = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/incident_log/import_incident_logs`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron las incidencias correctamente.`,
		})
		showSuccessMessage('Se registraron las incidencias correctamente')
		return res.body
	}
}

export default {
	...actions,
	addIncidentLog,
	updateIncidentLog,
	deleteIncidentLog,
	bulkSyncIncidentLog,
	loadIncidentLogs,
	importIncidentLogs,
}
